import React, { createContext, useEffect, useState } from "react";
import Home from "../../Template/Home/Home";
import { useNavigate } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import { Fetch } from "../../Hooks/Fetch";
import { userInfo } from "../../Hooks/URL";
import useFetchWhen from "../../Hooks/useFetchWhen";

function HomePage() {
  const navigate = useNavigate();

  const [contextData, setContextData] = useState({
    page: "",
    data: "",
    link: "",
    user: "",
  });
  const { data: userData } = useFetchWhen(userInfo, !contextData?.user);

  useEffect(() => {
    if (!contextData?.user) {
      setContextData({ ...contextData, user: userData?.data });
    }
  }, [userData]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const automaticLogin = params.get("automaticLogin");

    if (automaticLogin === "true") {
      localStorage.setItem("isLogged", "true");
      navigate("/");
    }

    if (localStorage.getItem("isLogged") == "false") navigate("/login");
  }, []);

  return (
    <userContext.Provider value={{ contextData, setContextData }}>
      <Home />
    </userContext.Provider>
  );
}

export default HomePage;
